import settingMenu from "./menuSettings";
import inputMenu from "./menuInputs";
import orderMenue from "./menuOrder";

const menu = [...settingMenu, ...inputMenu, ...orderMenue];

export default menu;
